"use strict";

var _defineProperty = require("/Users/chidumebinkata/chadmeter/chadmeter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _possibleConstructorReturn = require("/Users/chidumebinkata/chadmeter/chadmeter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/chidumebinkata/chadmeter/chadmeter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/chidumebinkata/chadmeter/chadmeter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _asyncToGenerator = require("/Users/chidumebinkata/chadmeter/chadmeter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _classCallCheck = require("/Users/chidumebinkata/chadmeter/chadmeter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/chidumebinkata/chadmeter/chadmeter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeAutoPaginationMethods = void 0;
var utils_js_1 = require("./utils.js");
var StripeIterator = /*#__PURE__*/function () {
  function StripeIterator(firstPagePromise, requestArgs, spec, stripeResource) {
    _classCallCheck(this, StripeIterator);
    this.index = 0;
    this.pagePromise = firstPagePromise;
    this.promiseCache = {
      currentPromise: null
    };
    this.requestArgs = requestArgs;
    this.spec = spec;
    this.stripeResource = stripeResource;
  }
  _createClass(StripeIterator, [{
    key: "iterate",
    value: function () {
      var _iterate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(pageResult) {
        var reverseIteration, idx, value, nextPageResult;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (pageResult && pageResult.data && typeof pageResult.data.length === 'number') {
                _context.next = 2;
                break;
              }
              throw Error('Unexpected: Stripe API response does not have a well-formed `data` array.');
            case 2:
              reverseIteration = isReverseIteration(this.requestArgs);
              if (!(this.index < pageResult.data.length)) {
                _context.next = 10;
                break;
              }
              idx = reverseIteration ? pageResult.data.length - 1 - this.index : this.index;
              value = pageResult.data[idx];
              this.index += 1;
              return _context.abrupt("return", {
                value: value,
                done: false
              });
            case 10:
              if (!pageResult.has_more) {
                _context.next = 17;
                break;
              }
              // Reset counter, request next page, and recurse.
              this.index = 0;
              this.pagePromise = this.getNextPage(pageResult);
              _context.next = 15;
              return this.pagePromise;
            case 15:
              nextPageResult = _context.sent;
              return _context.abrupt("return", this.iterate(nextPageResult));
            case 17:
              return _context.abrupt("return", {
                done: true,
                value: undefined
              });
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function iterate(_x) {
        return _iterate.apply(this, arguments);
      }
      return iterate;
    }() /** @abstract */
  }, {
    key: "getNextPage",
    value: function getNextPage(_pageResult) {
      throw new Error('Unimplemented');
    }
  }, {
    key: "_next",
    value: function () {
      var _next2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = this;
              _context2.next = 3;
              return this.pagePromise;
            case 3:
              _context2.t1 = _context2.sent;
              return _context2.abrupt("return", _context2.t0.iterate.call(_context2.t0, _context2.t1));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _next() {
        return _next2.apply(this, arguments);
      }
      return _next;
    }()
  }, {
    key: "next",
    value: function next() {
      var _this = this;
      /**
       * If a user calls `.next()` multiple times in parallel,
       * return the same result until something has resolved
       * to prevent page-turning race conditions.
       */
      if (this.promiseCache.currentPromise) {
        return this.promiseCache.currentPromise;
      }
      var nextPromise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var ret;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this._next();
            case 2:
              ret = _context3.sent;
              _this.promiseCache.currentPromise = null;
              return _context3.abrupt("return", ret);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
      this.promiseCache.currentPromise = nextPromise;
      return nextPromise;
    }
  }]);
  return StripeIterator;
}();
var ListIterator = /*#__PURE__*/function (_StripeIterator) {
  _inherits(ListIterator, _StripeIterator);
  function ListIterator() {
    _classCallCheck(this, ListIterator);
    return _possibleConstructorReturn(this, _getPrototypeOf(ListIterator).apply(this, arguments));
  }
  _createClass(ListIterator, [{
    key: "getNextPage",
    value: function getNextPage(pageResult) {
      var reverseIteration = isReverseIteration(this.requestArgs);
      var lastId = getLastId(pageResult, reverseIteration);
      return this.stripeResource._makeRequest(this.requestArgs, this.spec, _defineProperty({}, reverseIteration ? 'ending_before' : 'starting_after', lastId));
    }
  }]);
  return ListIterator;
}(StripeIterator);
var SearchIterator = /*#__PURE__*/function (_StripeIterator2) {
  _inherits(SearchIterator, _StripeIterator2);
  function SearchIterator() {
    _classCallCheck(this, SearchIterator);
    return _possibleConstructorReturn(this, _getPrototypeOf(SearchIterator).apply(this, arguments));
  }
  _createClass(SearchIterator, [{
    key: "getNextPage",
    value: function getNextPage(pageResult) {
      if (!pageResult.next_page) {
        throw Error('Unexpected: Stripe API response does not have a well-formed `next_page` field, but `has_more` was true.');
      }
      return this.stripeResource._makeRequest(this.requestArgs, this.spec, {
        page: pageResult.next_page
      });
    }
  }]);
  return SearchIterator;
}(StripeIterator);
var makeAutoPaginationMethods = function makeAutoPaginationMethods(stripeResource, requestArgs, spec, firstPagePromise) {
  if (spec.methodType === 'search') {
    return makeAutoPaginationMethodsFromIterator(new SearchIterator(firstPagePromise, requestArgs, spec, stripeResource));
  }
  if (spec.methodType === 'list') {
    return makeAutoPaginationMethodsFromIterator(new ListIterator(firstPagePromise, requestArgs, spec, stripeResource));
  }
  return null;
};
exports.makeAutoPaginationMethods = makeAutoPaginationMethods;
var makeAutoPaginationMethodsFromIterator = function makeAutoPaginationMethodsFromIterator(iterator) {
  var autoPagingEach = makeAutoPagingEach(function () {
    return iterator.next.apply(iterator, arguments);
  });
  var autoPagingToArray = makeAutoPagingToArray(autoPagingEach);
  var autoPaginationMethods = _defineProperty({
    autoPagingEach: autoPagingEach,
    autoPagingToArray: autoPagingToArray,
    // Async iterator functions:
    next: function next() {
      return iterator.next();
    },
    return: function _return() {
      // This is required for `break`.
      return {};
    }
  }, getAsyncIteratorSymbol(), function () {
    return autoPaginationMethods;
  });
  return autoPaginationMethods;
};
/**
 * ----------------
 * Private Helpers:
 * ----------------
 */
function getAsyncIteratorSymbol() {
  if (typeof Symbol !== 'undefined' && Symbol.asyncIterator) {
    return Symbol.asyncIterator;
  }
  // Follow the convention from libraries like iterall: https://github.com/leebyron/iterall#asynciterator-1
  return '@@asyncIterator';
}
function getDoneCallback(args) {
  if (args.length < 2) {
    return null;
  }
  var onDone = args[1];
  if (typeof onDone !== 'function') {
    throw Error("The second argument to autoPagingEach, if present, must be a callback function; received ".concat(typeof onDone));
  }
  return onDone;
}
/**
 * We allow four forms of the `onItem` callback (the middle two being equivalent),
 *
 *   1. `.autoPagingEach((item) => { doSomething(item); return false; });`
 *   2. `.autoPagingEach(async (item) => { await doSomething(item); return false; });`
 *   3. `.autoPagingEach((item) => doSomething(item).then(() => false));`
 *   4. `.autoPagingEach((item, next) => { doSomething(item); next(false); });`
 *
 * In addition to standard validation, this helper
 * coalesces the former forms into the latter form.
 */
function getItemCallback(args) {
  if (args.length === 0) {
    return undefined;
  }
  var onItem = args[0];
  if (typeof onItem !== 'function') {
    throw Error("The first argument to autoPagingEach, if present, must be a callback function; received ".concat(typeof onItem));
  }
  // 4. `.autoPagingEach((item, next) => { doSomething(item); next(false); });`
  if (onItem.length === 2) {
    return onItem;
  }
  if (onItem.length > 2) {
    throw Error("The `onItem` callback function passed to autoPagingEach must accept at most two arguments; got ".concat(onItem));
  }
  // This magically handles all three of these usecases (the latter two being functionally identical):
  // 1. `.autoPagingEach((item) => { doSomething(item); return false; });`
  // 2. `.autoPagingEach(async (item) => { await doSomething(item); return false; });`
  // 3. `.autoPagingEach((item) => doSomething(item).then(() => false));`
  return function _onItem(item, next) {
    var shouldContinue = onItem(item);
    next(shouldContinue);
  };
}
function getLastId(listResult, reverseIteration) {
  var lastIdx = reverseIteration ? 0 : listResult.data.length - 1;
  var lastItem = listResult.data[lastIdx];
  var lastId = lastItem && lastItem.id;
  if (!lastId) {
    throw Error('Unexpected: No `id` found on the last item while auto-paging a list.');
  }
  return lastId;
}
function makeAutoPagingEach(asyncIteratorNext) {
  return function autoPagingEach( /* onItem?, onDone? */
  ) {
    var args = [].slice.call(arguments);
    var onItem = getItemCallback(args);
    var onDone = getDoneCallback(args);
    if (args.length > 2) {
      throw Error("autoPagingEach takes up to two arguments; received ".concat(args));
    }
    var autoPagePromise = wrapAsyncIteratorWithCallback(asyncIteratorNext,
    // @ts-ignore we might need a null check
    onItem);
    return (0, utils_js_1.callbackifyPromiseWithTimeout)(autoPagePromise, onDone);
  };
}
function makeAutoPagingToArray(autoPagingEach) {
  return function autoPagingToArray(opts, onDone) {
    var limit = opts && opts.limit;
    if (!limit) {
      throw Error('You must pass a `limit` option to autoPagingToArray, e.g., `autoPagingToArray({limit: 1000});`.');
    }
    if (limit > 10000) {
      throw Error('You cannot specify a limit of more than 10,000 items to fetch in `autoPagingToArray`; use `autoPagingEach` to iterate through longer lists.');
    }
    var promise = new Promise(function (resolve, reject) {
      var items = [];
      autoPagingEach(function (item) {
        items.push(item);
        if (items.length >= limit) {
          return false;
        }
      }).then(function () {
        resolve(items);
      }).catch(reject);
    });
    // @ts-ignore
    return (0, utils_js_1.callbackifyPromiseWithTimeout)(promise, onDone);
  };
}
function wrapAsyncIteratorWithCallback(asyncIteratorNext, onItem) {
  return new Promise(function (resolve, reject) {
    function handleIteration(iterResult) {
      if (iterResult.done) {
        resolve();
        return;
      }
      var item = iterResult.value;
      return new Promise(function (next) {
        // Bit confusing, perhaps; we pass a `resolve` fn
        // to the user, so they can decide when and if to continue.
        // They can return false, or a promise which resolves to false, to break.
        onItem(item, next);
      }).then(function (shouldContinue) {
        if (shouldContinue === false) {
          return handleIteration({
            done: true,
            value: undefined
          });
        } else {
          return asyncIteratorNext().then(handleIteration);
        }
      });
    }
    asyncIteratorNext().then(handleIteration).catch(reject);
  });
}
function isReverseIteration(requestArgs) {
  var args = [].slice.call(requestArgs);
  var dataFromArgs = (0, utils_js_1.getDataFromArgs)(args);
  return !!dataFromArgs.ending_before;
}